@if (dataContext) {
  <div>
    @if (!isFollowing) {
      <fa-icon (click)="openModal()" #star [icon]="environment.icons.followOff" [fixedWidth]="true"></fa-icon>
      @if (showFollowText) {
        <span> Follow</span>
      }
    }
    @if (isFollowing) {
      <fa-icon (click)="openModal()" #star [icon]="environment.icons.followOn" [fixedWidth]="true"></fa-icon>
      <!--
      <span *ngIf="showFollowText">
        Following&nbsp;
        <span *ngIf="!isNotifying" class="fa fa-bell-slash" aria-hidden="true"></span>
        <span *ngIf="isNotifying" class="fa fa-bell" aria-hidden="true"></span>
      </span>
      -->
    }
  </div>
}
